import Slider from '../services/sliderService';

export default function bookSlider() {
    const elements = document.querySelectorAll('.js-book-slider');

    function createBookSlider(element, wrapper) {
        const options = {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slideVisibleClass: 'book-slider__item--visible',
            wrapperElement: wrapper,
        };

        return new Slider(element, options);
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.book-slider');

        createBookSlider(element, wrapper);
    });
}
